import { useEffect, useState } from "react";
import { Col, Form, Row } from "react-bootstrap";
import "./HdrTemplateNew.css";
import { useLocation, useParams } from "react-router-dom";
import {
  formatGermanFixedBy2,
  formatGermanInputForDecimal,
} from "../../../utility/NumberFormat";

const HdrTemplateNew = (props) => {
  // console.log(">>>>",props.resetFlag)
  const {
    resetFlag,
    resetText,
    year,
    div,
    onDataChange,
    wesData,
    singleData,
    templateWesNewPart,
    setTemplateWesNewPart,
  } = props;
  // console.log("resetFlag", resetFlag);
  // console.log("resetText", resetText);
  // console.log("singleData", props.singleData.hdr);
  // console.log("year, div", year, div)
  // Abschrift Prozentual Total

  const kollData = singleData?.partP?.find((item) => item.typId === "KOLL");

  // console.log("kollData", kollData)
  const nosData = singleData?.partP?.find((item) => item.typId === "NOS");

  // Abschrift Prozentual Total
  const abschriftTotal =
    (parseFloat(templateWesNewPart?.koll?.[0]?.percred || 0) +
      parseFloat(templateWesNewPart?.Nos?.[0]?.percred || 0)) /
    2;

  // Eingang Aufschlag Total
  const avgEingangAufschlagTotal =
    (parseFloat(templateWesNewPart?.koll?.[0]?.estimatedCalc || 0) +
      parseFloat(templateWesNewPart?.Nos?.[0]?.estimatedCalc || 0)) /
    2;
  const eingangAufschlagTotal =
    ((avgEingangAufschlagTotal + 100) / 100) * 100 - 100;

  // Eingang Abschlag Total
  const avgEingangAbschlagTotal =
    (parseFloat(templateWesNewPart?.koll?.[0]?.estimatedCalcDisc || 0) +
      parseFloat(templateWesNewPart?.Nos?.[0]?.estimatedCalcDisc || 0)) /
    2;

  const eingangAbschlagTotal =
    100 - ((100 - avgEingangAbschlagTotal) * 100) / 100;

  const eingAufschlagTotal =
    (parseFloat(templateWesNewPart?.koll?.[0]?.outgoingCalc || 0) +
      parseFloat(templateWesNewPart?.Nos?.[0]?.outgoingCalc || 0)) /
    2;

  const avgAbschriftPercent =
    (parseFloat(templateWesNewPart?.koll?.[0]?.percred || 0) +
      parseFloat(templateWesNewPart?.Nos?.[0]?.percred || 0)) /
    2;

  // const eingAufschlagTotal = (eingangAbschlagTotal + 100) * (100 - avgAbschriftPercent) / 100 / (100) * 100 -100
  // const eingAufschlagTotal =
  //   (((avgEingangAufschlagTotal + 100) * (100 - abschriftTotal)) / 100 / 100) *
  //     100 -
  //   100;

  const nachEingAbschlagTotal =
    (parseFloat(templateWesNewPart?.koll?.[0]?.outgoingCalcDisc || 0) +
      parseFloat(templateWesNewPart?.Nos?.[0]?.outgoingCalcDisc || 0)) /
    2;

  // const nachEingAbschlagTotal =
  //   100 - ((100 - avgNachEingAbschlagTotal) * 100) / 100;

  const lugTotal =
    (parseFloat(templateWesNewPart?.koll?.[0]?.lugPlan || 0) +
      parseFloat(templateWesNewPart?.Nos?.[0]?.lugPlan || 0)) /
    2;

  const location = useLocation();
  const isDisabled =
    location.pathname.startsWith("/newScreen-template/") &&
    !location.pathname.endsWith("_copy");

  const [hdrDivValue, setHdrDivValue] = useState({
    description: "",
    companyId: "12345",
    planYear: year,
    division: div,
    distributor: "GoPlan",
    area: "Delhi",
    vtrGroup: "Admin",
    deliveryId: "",
    soldTo: "",
    isAbhangig: true,
    mitWertValue: "",
    ausgangskalkulationAufschlag: "",
    durchschnittsEK: "0.0",
    eingangskalkulationAufschlag: "",
    abschriftPercent: "",
    eingangskalkulationAbschlag: "",
    lug: "",
    ausgangskalkulationAbschlag: "",
  });
  // console.log("hdrDivValue", typeof hdrDivValue.soldTo)

  // update parent also
  useEffect(() => {
    if (onDataChange) {
      // console.log("onDataChange", hdrDivValue)
      props.onDataChange(hdrDivValue);
    }
  }, [hdrDivValue, props]);

  useEffect(() => {
    if (resetFlag && !resetText) {
      setHdrDivValue((prev) => ({
        ...prev,
        description: "",
        soldTo: "",
        planYear: year || "",
        division: div || "",
        ausgangskalkulationAufschlag: "",
        durchschnittsEK: "0.0",
        eingangskalkulationAufschlag: "",
        abschriftPercent: "",
        eingangskalkulationAbschlag: "",
        lug: "",
        ausgangskalkulationAbschlag: "",
      }));
      return;
    }

    if (resetText) {
      setHdrDivValue((prev) => ({
        ...prev,
        description: "",
        soldTo: "",
        planYear: year || "",
        division: div || "",
      }));
      return;
    }

    if (props?.singleData?.hdr) {
      setHdrDivValue((prev) => {
        const updated = {
          ...prev,
          description: props.singleData.hdr.description || "",
          soldTo: props.singleData.hdr.soldTo || "",
          planYear: year ? year : "",
          division: div ? div : "",
          durchschnittsEK: "0.0",
        };

        // console.log("UPDATED OBJECT", updated);

        return updated;
      });
    }
  }, [props?.singleData?.hdr, resetFlag, resetText, year, div]);

  // value set
  useEffect(() => {
    // console.log({
    //   eingAufschlagTotal,
    //   eingangAufschlagTotal,
    //   abschriftTotal,
    //   eingangAbschlagTotal,
    //   lugTotal,
    //   nachEingAbschlagTotal,
    // });

    setHdrDivValue((prev) => {
      const updated = {
        ...prev,
        ausgangskalkulationAufschlag: eingAufschlagTotal,
        eingangskalkulationAufschlag: eingangAufschlagTotal,
        abschriftPercent: abschriftTotal,
        eingangskalkulationAbschlag: eingangAbschlagTotal,
        lug: lugTotal,
        ausgangskalkulationAbschlag: nachEingAbschlagTotal,
      };

      // console.log("updated HDR", updated);
      return updated;
    });
  }, [
    eingAufschlagTotal,
    eingangAufschlagTotal,
    abschriftTotal,
    eingangAbschlagTotal,
    lugTotal,
    nachEingAbschlagTotal,
  ]);

  const handleChange = (e) => {
    const { name, type, value } = e.target;

    //  Allow ONLY numbers + ONE decimal (dot or comma)
    if (type === "text" && name !== "description") {
      // remove thousand separators for checking
      const raw = value.replace(/\./g, "");

      //  block alphabets & special chars
      if (!/^\d*([.,]?\d*)?$/.test(raw)) {
        return;
      }

      // limit decimals to 2
      const parts = raw.split(/[.,]/);
      if (parts.length > 1 && parts[1].length > 2) {
        return;
      }
    }

    // Remove thousand separators (typing phase)
    const cleaned = value.replace(/\./g, "");

    setHdrDivValue((prev) => ({
      ...prev,
      [name]: cleaned,
    }));
  };

  const handleBlurHDR = (e) => {
    const { name, value } = e.target;

    if (!value) return;

    const cleaned = value.replace(/\./g, ""); // 1.234,56 → 1234,56
    const normalized = cleaned.replace(",", "."); // → 1234.56

    const num = Number(normalized);
    if (Number.isNaN(num)) return;

    setHdrDivValue((prev) => ({
      ...prev,
      [name]: num,
    }));
  };

  // console.log('hdr value??', hdrDivValue)

  return (
    <div className="hdrContainer_main">
      {/* Beschreibung */}
      <Row>
        <Col md={4}>
          <Form.Label>Beschreibung</Form.Label>
        </Col>
        <Col md={8}>
          <Form.Control
            type="text"
            name="description"
            className="hdr-form-control_1"
            value={hdrDivValue.description}
            onChange={handleChange}
            maxLength={70}
            required
            autoComplete="off"
          />
        </Col>
      </Row>

      {/* First Dependency Row - Active */}
      <Row className="mt-1">
        <Col md={4}>
          <Form.Check
            type="checkbox"
            label="Abhangig von"
            name="isAbhangig"
            className="hdr-form-check"
            checked={hdrDivValue.isAbhangig}
            onChange={handleChange}
          />
        </Col>
        <Col md={6}>
          <Form.Select
            name="soldTo"
            className="hdr-form-select"
            value={String(hdrDivValue.soldTo || "")}
            onChange={handleChange}
            disabled={!hdrDivValue.isAbhangig}
          >
            <option value="">Select Kd</option>
            {[...new Set(props.KdNo)]?.map((item, index) => (
              <option key={index} value={item} id={index}>
                {item}
              </option>
            ))}
          </Form.Select>
        </Col>
      </Row>

      {/* Second Dependency Row - Disabled */}
      <Row className="mt-1">
        <Col
          md={6}
          // style={{ display: "flex", alignItems: "center", gap: "6px" }}
        >
          <Form.Label className="m-0 p-0">Abschrift %</Form.Label>
        </Col>
        <Col md={6}>
          <Form.Control
            type="text"
            name="abschriftPercent"
            className="hdr-form-control"
            // value={formatGermanFixedBy2(hdrDivValue.abschriftPercent)}
            value={formatGermanFixedBy2(abschriftTotal || "")}
            onChange={handleChange}
            onBlur={handleBlurHDR}
            style={{
              border: " 1px solid rgb(247, 246, 215)",
              background: "rgb(247, 246, 215)",
            }}
            disabled
          />
        </Col>
      </Row>

      {/* Third Calculation Row */}
      <Row className="mt-1">
        <Col
          md={6}
          // style={{ display: "flex", alignItems: "center", gap: "6px" }}
        >
          <Form.Label className="m-0 p-0">
            Eingangskalkulation (Aufschlag)
          </Form.Label>
        </Col>
        <Col md={6}>
          <Form.Control
            type="text"
            name="eingangskalkulationAufschlag"
            className="hdr-form-control"
            // value={formatGermanFixedBy2(hdrDivValue.eingangskalkulationAufschlag || "")}
            value={formatGermanFixedBy2(eingangAufschlagTotal || "")}
            onChange={handleChange}
            onBlur={handleBlurHDR}
            style={{
              border: " 1px solid rgb(247, 246, 215)",
              background: "rgb(247, 246, 215)",
            }}
            disabled
          />
        </Col>
      </Row>

      {/* Fourth Dependency Row - Disabled */}
      <Row className="mt-1">
        <Col
          md={6}
          // style={{ display: "flex", alignItems: "center", gap: "6px" }}
        >
          <Form.Label className="m-0 p-0">
            Eingangskalkulation (Abschlag)
          </Form.Label>
        </Col>
        <Col md={6}>
          <Form.Control
            type="text"
            name="eingangskalkulationAbschlag"
            className="hdr-form-control"
            // value={formatGermanFixedBy2(hdrDivValue.eingangskalkulationAbschlag)}
            value={formatGermanFixedBy2(eingangAbschlagTotal || "")}
            onChange={handleChange}
            onBlur={handleBlurHDR}
            style={{
              border: " 1px solid rgb(247, 246, 215)",
              background: "rgb(247, 246, 215)",
            }}
            disabled
          />
        </Col>
      </Row>

      {/* Fivth Dependency Row - Disabled */}
      <Row className="mt-1">
        <Col
          md={6}
          // style={{ display: "flex", alignItems: "center", gap: "6px" }}
        >
          <Form.Label className="m-0 p-0">
            Ausgangskalkulation (Aufschlag)
          </Form.Label>
        </Col>
        <Col md={6}>
          <Form.Control
            type="text"
            name="ausgangskalkulationAufschlag"
            className="hdr-form-control"
            // value={formatGermanFixedBy2(hdrDivValue.ausgangskalkulationAufschlag)}
            value={formatGermanFixedBy2(eingAufschlagTotal || "")}
            onChange={handleChange}
            onBlur={handleBlurHDR}
            style={{
              border: " 1px solid rgb(247, 246, 215)",
              background: "rgb(247, 246, 215)",
            }}
            disabled
          />
        </Col>
      </Row>

      {/* sixth Calculation Row */}
      <Row className="mt-1">
        <Col
          md={6}
          // style={{ display: "flex", alignItems: "center", gap: "6px" }}
        >
          <Form.Label className="m-0 p-0">
            Ausgangskalkulation (Abschlag)
          </Form.Label>
        </Col>
        <Col md={6}>
          <Form.Control
            type="text"
            name="ausgangskalkulationAbschlag"
            className="hdr-form-control"
            // value={formatGermanFixedBy2(hdrDivValue.ausgangskalkulationAbschlag)}
            value={formatGermanFixedBy2(nachEingAbschlagTotal || "")}
            onChange={handleChange}
            onBlur={handleBlurHDR}
            style={{
              border: " 1px solid rgb(247, 246, 215)",
              background: "rgb(247, 246, 215)",
            }}
            disabled
          />
        </Col>
      </Row>

      {/* Seventh Dependency Row - Disabled */}
      <Row className="mt-1">
        <Col
          md={6}
          // style={{ display: "flex", alignItems: "center", gap: "6px" }}
        >
          <Form.Label className="m-0 p-0">LUG</Form.Label>
        </Col>
        <Col md={6}>
          <Form.Control
            type="text"
            name="lug"
            className="hdr-form-control"
            // value={formatGermanFixedBy2(hdrDivValue.lug)}
            value={formatGermanFixedBy2(lugTotal || "")}
            onChange={handleChange}
            onBlur={handleBlurHDR}
            style={{
              border: " 1px solid rgb(247, 246, 215)",
              background: "rgb(247, 246, 215)",
            }}
            disabled
          />
        </Col>
      </Row>
    </div>
  );
};
export default HdrTemplateNew;
